import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Avatar, Paper } from "@material-ui/core";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import FormRender from "../../../../Fields/FormRender";
import createEventConfig from "./createEventconfig.json";
import { createPublicEvent } from "../../../../../data-store/actions/events-actions";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  paper: {
    padding: "20px",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
  },
  buttons: {
    margin: 30,
    width: "250px",
    color: "black",
  },
}));

export default function EventCreateForm() {
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);

  const createEventObject = createEventConfig.createEvent;

  const classes = useStyles();

  // "formulario" -> "creando" -> "creado" | "error". Evita que, mientras se
  // escribe en Firebase, el admin siga viendo el formulario y crea (con
  // razón) que el clic no funcionó y lo repita, duplicando el evento.
  const [fase, setFase] = useState("formulario");
  const [eventoCreadoIndex, setEventoCreadoIndex] = useState(null);

  function resetearDialogo() {
    setFase("formulario");
    setEventoCreadoIndex(null);
  }

  function onSubmit(data) {
    console.log(data);

    setFase("creando");
    dispatch(createPublicEvent(data, userID, atleteAccount))
      .then((eventoIndex) => {
        setEventoCreadoIndex(eventoIndex);
        setFase("creado");
      })
      .catch((error) => {
        console.log("Error creando evento", error);
        setFase("error");
      });
  }

  const eventView = (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <Grid container direction="column" alignItems="center">
          {fase === "formulario" && (
            <>
              <Grid item xs={12}>
                <Typography gutterBottom variant={"h4"} component="h2">
                  Crea un evento Nuevo
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} style={{ margin: "20px" }}>
                <FormRender
                  callback={onSubmit}
                  formObject={createEventObject}
                  submitButtonText={"Crear Evento"}
                />
              </Grid>
            </>
          )}
          {fase === "creando" && (
            <Grid item xs={12} style={{ margin: "40px 20px", textAlign: "center" }}>
              <CircularProgress />
              <Typography gutterBottom variant={"h5"} component="h2" style={{ marginTop: 20 }}>
                Creando evento...
              </Typography>
              <Typography gutterBottom variant={"body1"}>
                No cierres esta ventana, puede tardar unos segundos.
              </Typography>
            </Grid>
          )}
          {fase === "creado" && (
            <Grid item xs={12} style={{ margin: "40px 20px", textAlign: "center" }}>
              <Typography
                gutterBottom
                variant={"h5"}
                component="h2"
                style={{
                  background: "#c8e6c9",
                  color: "#1b5e20",
                  padding: 10,
                  borderRadius: 4,
                }}
              >
                Evento creado correctamente
              </Typography>
              <Button
                component={Link}
                to={`/eventos-organizados/${eventoCreadoIndex}`}
                variant="contained"
                color="primary"
                style={{ marginTop: 20 }}
              >
                Ir al evento creado
              </Button>
            </Grid>
          )}
          {fase === "error" && (
            <Grid item xs={12} style={{ margin: "40px 20px", textAlign: "center" }}>
              <Typography
                gutterBottom
                variant={"h5"}
                component="h2"
                style={{
                  background: "#ffcdd2",
                  color: "#b71c1c",
                  padding: 10,
                  borderRadius: 4,
                }}
              >
                Ocurrió un error al crear el evento, intenta de nuevo.
              </Typography>
              <Button
                onClick={resetearDialogo}
                variant="contained"
                color="primary"
                style={{ marginTop: 20 }}
              >
                Volver a intentar
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </Paper>
  );

  // no mostrar la opción de crear eventos apara usuarios perfil 2

  if (atleteAccount.perfil === 2) {
    return false
  }

  return (
    <Paper
      style={{
        padding: 20,
        margin: 20,
        backgroundColor: "#e0e0e0",
      }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} sm={12}>
          <Typography variant={"h4"} color="primary" align="center">
            Crear un evento
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <SimpleDialogDemo buttonText={"Nuevo evento"} onOpen={resetearDialogo}>
            {eventView}
          </SimpleDialogDemo>
        </Grid>
      </Grid>
    </Paper>
  );
}
